import { PlanLocatedMaterial } from '../../../models/materials.models'
import Constants from '../../../constants'

const LocatedMaterial = ({
  size = Constants.ui.pixelLocatedMaterial,
  isSelected,
  isTmp,
  _id,
  position,
  angle,
  primaryCategory,
  isMaterialSelected,
  displayMode,
  code,
}: PlanLocatedMaterial & {
  size: number
  angle: number
  code?: string
  displayMode?: 'icon' | 'code'
}): JSX.Element => {
  const seleted = isTmp || isSelected
  if (primaryCategory) {
    const img = Constants.getCategoryIcon(primaryCategory)
    if (img) {
      return (
        <g>
          {(isMaterialSelected || seleted) && displayMode === 'icon' && (
            <circle
              id={`locatedMaterial.${_id}`}
              cx={position[0]}
              cy={position[1]}
              r={size / 2}
              fill={'transparent'}
              stroke={Constants.colors.primary}
              strokeWidth={seleted ? 4 : 1}
              style={{ cursor: 'pointer' }}
            />
          )}

          {displayMode === 'icon' && (
            <image
              transform={`rotate(${angle} ${position[0]} ${position[1]})`}
              id={`locatedMaterial.${_id}`}
              xlinkHref={img}
              x={position[0] - size / 2}
              y={position[1] - size / 2}
              height={size}
              width={size}
              style={{ cursor: 'pointer' }}
            />
          )}
          {displayMode === 'code' && (
            <text
              id={`locatedMaterial.${_id}`}
              x={position[0]}
              y={position[1]}
              textAnchor="middle"
              filter={
                (isMaterialSelected || seleted)
                  ? 'url(#codeBackgroundSelected)'
                  : 'url(#codeBackground)'
              }
              dominantBaseline="middle"
              fontSize={size / 3}
              fontWeight={600}
              fill={
                (isMaterialSelected || seleted) ? Constants.colors.white : Constants.colors.primary
              }
              style={{ cursor: 'pointer' }}>
              {code}
            </text>
          )}
        </g>
      )
    }
  }
  return (
    <circle
      id={`locatedMaterial.${_id}`}
      cx={position[0]}
      cy={position[1]}
      r={size / 2}
      fill={seleted ? Constants.colors.primary : ''}
    />
  )
}
export default LocatedMaterial
